import React, { useMemo } from 'react';
import useVehicleWarrantyClaimsReport from './hooks/useVehicleWarrantyClaimsReport';
import VehicleWarrantyClaimsFilter from './components/VehicleWarrantyClaimsFilter';
import VehicleWarrantyClaimsTable from './components/VehicleWarrantyClaimsTable';
import { useLanguage } from '../../../contexts/LanguageContext';
import { getVehicleWarrantyClaimsColumns } from './helpers/getVehicleWarrantyClaimsColumns';
import { useLazyExportVehicleWarrantyClaimsToExcelQuery } from '../../../api/endpoints/vehicleWarrantyClaimsReport';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';


export default function VehicleWarrantyClaimsReportPage() {
    const { th } = useLanguage();


    const {
        items,
        totalCount,
        isFetching,
        lazyParams,
        hasApplied,
        isDealer,
        applyFilters,
        resetFilters,
        onPage,
        exportParams,
    } = useVehicleWarrantyClaimsReport();

      const columns = useMemo(() => getVehicleWarrantyClaimsColumns(th, isDealer), [th, isDealer]);


    

    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('vehicleWarrantyClaims.title')}</h1>

                <GenericFileExportButton
                    useExportQuery={useLazyExportVehicleWarrantyClaimsToExcelQuery}
                    exportParams={exportParams}
                    buttonLabel={th('common.export') || 'Excel'}
                    buttonClassName="p-button-success"
                    icon="pi pi-file-excel"
                    fileNameExtractor={(result) => result?.fileName || 'garanti_talepleri.xlsx'}
                    dataExtractor={(result) => result?.blob || result?.fileBase64} // Blob öncelikli, fallback Base64
                    contentTypeExtractor={(result) => result?.contentType}
                    exportFormat="auto" // Otomatik algılama (blob veya base64)
                    disabled={!hasApplied || !items?.length}
                />
            </div>

            <VehicleWarrantyClaimsFilter onApplyFilters={applyFilters} onResetFilters={resetFilters} />

            {hasApplied && (
                <div className="mt-3">
                    <VehicleWarrantyClaimsTable
                        items={items}
                        totalCount={totalCount}
                        loading={isFetching}
                        lazyParams={lazyParams}
                        onPage={onPage}
                        columns={columns}
                    />
                </div>
            )}

            {!isFetching && hasApplied && items.length === 0 && (
                <div className="flex justify-content-center align-items-center p-5">
                    <p className="text-500">{th('common.noRecords')}</p>
                </div>
            )}
        </div>
    );
}